$(document).ready(function(){
$('.costom-demo-collection').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
   singleItem:true,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
     {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
      }
    }
   
    
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
$('.popular-demo-collection').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 7,
   singleItem:true,
   autoplay: true,
   autoplaySpeed: 4000,
   arrows: false,
  slidesToScroll: 7,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 7,
        slidesToScroll: 7,
        infinite: true,
        dots: false
      }
    },
     {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      
        
      }
    }
   
    
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('.custom_rew_section').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
   singleItem:true,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
     {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
      }
    }
   
    
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$(document).ready(function() {
  
 
  $(".accordion_question").on("click",function(){
    let answer_id = $(this).attr('id');
    if($(this).hasClass('active_toggle')){
      $('.accordion_question').removeClass('active_toggle');
      $('.paragraph').hide();
    }else{
      $('.accordion_question').removeClass('active_toggle');
      $(this).addClass('active_toggle');
      $('.paragraph').hide();
    	$('.answer_'+answer_id).show();
    }  
    
  });


//   $('.flexslider').flexslider({
//     animation: "slide",
//     controlNav: "thumbnails"
//   });
  
  $('#slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    dots: false,
    asNavFor: "#carousel",
    
  });
  $('.zoom').zoom();

});
   $('#carousel').slick({
     slidesToShow: 3,
     slidesToScroll: 3,
     arrows: true,
     dots: false,
     infinite:true,
     centerMode: true,
     focusOnSelect: true,
     asNavFor: '#slider',
     responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            centerMode: true,
            slidesToShow: 3
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: true,
            centerMode: true,
            slidesToShow: 3
          }
        }
      ]
  });
  $('.product-form__input input[type=radio] ').click(function () {
      setTimeout(function(){
     var main_id = $("input.zooomyvariantselect").attr("value");
        console.log('main-id',main_id);
          $('.custom-varient .variant-data').each(function(){
            var varids=$(this).attr("data-id");
            console.log('varid',varids);
            if(main_id == varids){
                var price = $(this).attr("varient_img");
              console.log(price);
                $('#carousel .cstm-media-gallery-slider').each(function(){
                    var slider_id =$(this).attr("media_img_url");
                  console.log(slider_id);
                    if(price == slider_id){
                        $(this).trigger( "click" );
                        
                    }
                })
              var title = $(this).attr("variant-title");
              $('.product__title').html(title);
              
              var desc = $(this).find(".variant-description").html();
              // console.log(desc);
              $('.product-descriptions').html(desc);

              var items = $(this).find(".product_points").html();
               // console.log(items);
              $('.product-bullet-heading').html(items);
        }
        });
         
      },200);
  });
$( window ).on("load", function() {
     var main_id = $("input.zooomyvariantselect").attr("value");
          $('.custom-varient .variant-data').each(function(){
            var varids=$(this).attr("data-id");
            if(main_id == varids){
                var price = $(this).attr("varient_img");
                $('#carousel .cstm-media-gallery-slider').each(function(){
                    var slider_id =$(this).attr("media_img_url");
                    if(price == slider_id){
                        $(this).trigger( "click" );   
                    }
                })
        }
        });
});
 
    
});
